onComplete(function () {
  const pageScrollThreshold = 50;

  // Page menu.
  const pageMenu = document.querySelector('.page-menu');
  window.addEventListener('scroll', function () {
    const scroll = window.scrollY ? window.scrollY : document.documentElement.scrollTop ? document.documentElement.scrollTop : 0;
    if (pageMenu) {
      if (scroll >= pageScrollThreshold) {
        pageMenu.classList.add('scroll');
      } else {
        pageMenu.classList.remove('scroll');
      }
    }
  });

  // Mobile Menu
  const hamburger = document.querySelector('.hamburger');
  const navbarMobile = document.querySelector('.navbar-mobile');
  const headerMobile = document.querySelector('.mobile-header');
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (navbarMobile) {
        navbarMobile.classList.toggle('navbar--open');
      }
      if (headerMobile) {
        headerMobile.classList.toggle('navbar--open');
      }
      document.body.classList.toggle('fixed');
    });
  }

  // Quick menu.
  const quickMenu = document.querySelector('.quick-menu nav.navlist');
  if (quickMenu) {
    quickMenu.addEventListener('click', function () {
      quickMenu.classList.toggle('quick-menu--open');
    });
  }
  if (document.documentElement.getAttribute('data-home') === 'true') {
    let homeInterval;
    homeInterval = setInterval(function () {
      let homeDiv = document.querySelector('.upcoming_home>div');
      if (homeDiv && homeDiv.textContent !== '') {
        let homeImg = document.querySelector('.upcoming_home img');
        let homeTd = document.querySelectorAll('.upcoming_home td')[1];
        if (homeImg && homeTd) {
          homeImg.setAttribute('src', "https://logoapi.voetbal.nl/logo.php?clubcode=" + homeTd.textContent);
          homeImg.addEventListener('load', function () {
            homeImg.setAttribute('width', homeImg.naturalWidth);
            homeImg.setAttribute('height', homeImg.naturalHeight);
          });
        }
        clearInterval(homeInterval);
      }
    }, 100);
    let upcomingInterval;
    upcomingInterval = setInterval(function () {
      let awayDiv = document.querySelector('.upcoming_away>div');
      if (awayDiv && awayDiv.textContent !== '') {
        let awayImg = document.querySelector('.upcoming_away img');
        let awayTd = document.querySelectorAll('.upcoming_away td')[1];
        if (awayImg && awayTd) {
          awayImg.setAttribute('src', "https://logoapi.voetbal.nl/logo.php?clubcode=" + awayTd.textContent);
          awayImg.addEventListener('load', function () {
            awayImg.setAttribute('width', awayImg.naturalWidth);
            awayImg.setAttribute('height', awayImg.naturalHeight);
          });
        }
        clearInterval(upcomingInterval);
      }
    }, 100);
    let zaHomeInterval;
    zaHomeInterval = setInterval(function () {
      let zaHomeDiv = document.querySelector('.zaterdag .upcoming_home>div');
      if (zaHomeDiv && zaHomeDiv.textContent !== '') {
        let zaHomeImg = document.querySelector('.zaterdag .upcoming_home img');
        let zaHomeTd = document.querySelectorAll('.zaterdag .upcoming_home td')[1];
        if (zaHomeImg && zaHomeTd) {
          zaHomeImg.setAttribute('src', "https://logoapi.voetbal.nl/logo.php?clubcode=" + zaHomeTd.textContent);
          zaHomeImg.addEventListener('load', function () {
            zaHomeImg.setAttribute('width', zaHomeImg.naturalWidth);
            zaHomeImg.setAttribute('height', zaHomeImg.naturalHeight);
          });
        }
        clearInterval(zaHomeInterval);
      }
    }, 100);
    let zaUpcomingInterval;
    zaUpcomingInterval = setInterval(function () {
      let zaAwayDiv = document.querySelector('.zaterdag .upcoming_away>div');
      if (zaAwayDiv && zaAwayDiv.textContent !== '') {
        let zaAwayImg = document.querySelector('.zaterdag .upcoming_away img');
        let zaAwayTd = document.querySelectorAll('.zaterdag .upcoming_away td')[1];
        if (zaAwayImg && zaAwayTd) {
          zaAwayImg.setAttribute('src', "https://logoapi.voetbal.nl/logo.php?clubcode=" + zaAwayTd.textContent);
          zaAwayImg.addEventListener('load', function () {
            zaAwayImg.setAttribute('width', zaAwayImg.naturalWidth);
            zaAwayImg.setAttribute('height', zaAwayImg.naturalHeight);
          });
        }
        clearInterval(zaUpcomingInterval);
      }
    }, 100);
  }
});